import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { DialogService } from './core/services/dialog.service';
import { NotificationService } from './core/services/notification.service';
import { ConfirmDialogComponent } from './shared/ui/confirm-dialog/confirm-dialog.component';
import { PromptDialogComponent } from './shared/ui/prompt-dialog/prompt-dialog.component';
import { ToastComponent } from './shared/ui/toast/toast.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, ConfirmDialogComponent, PromptDialogComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly notificationService = inject(NotificationService);
  protected readonly dialogService = inject(DialogService);
}
